import { Link } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'

export function EmailVerifiedPage() {
  const { user } = useAuthStore()
  const isAuthenticated = !!user

  // If the session is still alive from the email-confirmation step,
  // skip the sign-in form and go straight into onboarding.
  // ProtectedRoute on /onboarding handles the auth check, and onboarding
  // routes the user to dashboard once complete.
  const continueTo = isAuthenticated ? '/onboarding' : '/auth/sign-in'

  return (
    <div
      className="min-h-screen flex flex-col bg-[#F1ECDF] bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: 'url(/verify-bg.jpg)' }}
    >
      {/* Top-left home link */}
      <header className="px-6 py-5">
        <Link
          to="/"
          className="text-[14px] text-[#0F1C2E]/70 hover:text-[#0F1C2E] transition-colors"
        >
          ← Home
        </Link>
      </header>

      {/* Centered content */}
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-[440px] text-center">
          <img
            src="/logo-email.png"
            alt="Drive Without Fear"
            className="w-12 h-12 mx-auto mb-8"
          />
          <h1 className="text-[28px] sm:text-[32px] font-semibold text-[#0F1C2E] mb-3">
            Account verified
          </h1>
          <p className="text-[15px] text-[#0F1C2E]/70 mb-10">
            {isAuthenticated
              ? "Your email has been confirmed. You're all set to begin."
              : 'Your email has been confirmed. You can now log in to start your journey.'}
          </p>
          <Link
            to={continueTo}
            className="inline-flex items-center justify-center w-full sm:w-auto sm:min-w-[280px] h-[52px] px-8 bg-[#0F1C2E] text-white font-semibold rounded-full hover:bg-[#1B2A4A] transition-colors"
          >
            Log in
          </Link>
          <p className="mt-8 text-[13px] text-[#0F1C2E]/60">
            Need help? Contact{' '}
            <a
              href="mailto:support@drivewithoutfear.com"
              className="underline hover:text-[#0F1C2E]"
            >
              support@drivewithoutfear.com
            </a>
          </p>
        </div>
      </main>
    </div>
  )
}
